import { Modal } from '@iwoca/orion';
import { includes } from 'lodash';
import { connect } from 'react-redux';

import styles from './AutomatedLendingDecision.module.css';
import CheckingApplication from './CheckingEligibility/CheckingEligibility';
import DEApprovalPropability, {
    DE_AP_HIGH_PROBABILITY,
    DE_AP_MEDIUM_PROBABILITY,
    DE_AP_LOW_PROBABILITY
} from './DEApprovalPropability/DEApprovalPropability';
import DecisionError from './DecisionError/DecisionError';
import ExitPoll from './ExitPoll/ExitPoll';

const mapStateToProps = ({ automatedLendingDecision }) =>
    automatedLendingDecision;

const AutomatedLendingDecision = ({ onClose, isOpen, step, ...otherProps }) => {
    const isVisible =
        isOpen &&
        includes(
            [
                'CHECKING_APPLICATION',
                'ERROR',
                DE_AP_HIGH_PROBABILITY,
                DE_AP_MEDIUM_PROBABILITY,
                DE_AP_LOW_PROBABILITY
            ],
            step
        );

    let content = null;
    switch (step) {
        case 'CHECKING_APPLICATION':
            content = <CheckingApplication />;
            break;
        case 'ERROR':
            content = <DecisionError />;
            break;
        case DE_AP_HIGH_PROBABILITY:
        case DE_AP_MEDIUM_PROBABILITY:
        case DE_AP_LOW_PROBABILITY:
            return (
                <DEApprovalPropability
                    lendingDecisionStep={step}
                    show={isVisible}
                    onClose={onClose}
                />
            );

        default:
            break;
    }

    return (
        <Modal
            data-testid="automated-lending-decision-modal"
            className={styles.modalContainer}
            onClose={onClose}
            isOpen={isVisible}
            closeIcon
            headerBar
            {...otherProps}>
            <div data-testid="loan-modal-contents">
                {content}
                <ExitPoll />
            </div>
        </Modal>
    );
};

export default connect(mapStateToProps)(AutomatedLendingDecision);
